import { render, staticRenderFns } from "./TestCalculation.vue?vue&type=template&id=16fd27d7&scoped=true"
import script from "./TestCalculation.vue?vue&type=script&lang=js"
export * from "./TestCalculation.vue?vue&type=script&lang=js"
import style0 from "./TestCalculation.vue?vue&type=style&index=0&id=16fd27d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fd27d7",
  null
  
)

export default component.exports